import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styleable from 'react-styleable';
import defaultStyle from './paged-list.style';
import LoadingPane from './loading-pane';
import GenericError from './generic-error';

export class Table extends Component {

  render() {
    const { header, items, mapItem, emptyMessage, isLoading,
      css, loadingMessage, contentLoadedMessage, loadingErr } = this.props;

    if(loadingErr) {
      return <GenericError err={loadingErr}/>
    }

    return(
      <table id="summary-table" className={css.table}>
        <thead>
          {header}
        </thead>
        <LoadingPane
          isLoading={isLoading}
          loadingMessage={loadingMessage}
          contentLoadedMessage={contentLoadedMessage}
          type='tbody'>
          {items.length > 0 ? items.map((item, index) => (
            mapItem(item, index)
          )) : <div id="emptyMessage">{emptyMessage}</div>}
        </LoadingPane>
      </table>
    );
  }
}

Table.defaultProps = {
  loadingMessage : 'Loading...',
  contentLoadedMessage : 'Content Loaded',
}

Table.propTypes = {
  header: PropTypes.element.isRequired,
  items: PropTypes.array.isRequired,
  emptyMessage: PropTypes.element,
  loadingMessage: PropTypes.string,
  contentLoadedMessage: PropTypes.string,
  mapItem: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  loadingErr: PropTypes.object,
};

export default styleable(defaultStyle) (Table);
